import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=01a1a277&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=01a1a277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1a277",
  null
  
)

export default component.exports